import { combineReducers } from "redux"

import attachments from "./attachment-entity-reducer"
import authors from "./authors-entity-reducer"
import clusters from "./cluster-entity-reducer"
import communities from "./community-entity-reducer"
import concepts from "./concept-entity-reducer"
import dashboardInfo from "./dashboard-info-entity-reducer"
import dimensions from "./dimension-entity-reducer"
import evidence from "./evidence-entity-reducer"
import knowledge from "./knowledge-entity-reducer"
import knowledgeFulltext from "./knowledge-fulltext-entity-reducer"
import knowledgeData from "./knowledge-data-entity-reducer"
import maps from "./map-entity-reducer"
import notifications from "./notification-entity-reducer"
import projects from "./project-entity-reducer"
import reports from "./report-entity-reducer"
import roles from "./role-entity-reducer"
import sessions from "./session-entity-reducer"
import sources from "./source-entity-reducer"
import stakeholders from "./stakeholder-entity-reducer"
import topicFingerprints from "./topic-fingerprint-entity-reducer"
import topicKnowledge from "./topic-knowledge-reducer"
import topicVolumes from "./topic-volumes-reducer"
import topics from "./topic-entity-reducer"
import users from "./user-entity-reducer"

export default combineReducers({
    attachments,
    authors,
    clusters,
    communities,
    concepts,
    dashboardInfo,
    dimensions,
    evidence,
    knowledge,
    knowledgeFulltext,
    knowledgeData,
    maps,
    notifications,
    projects,
    reports,
    roles,
    sessions,
    sources,
    stakeholders,
    topicFingerprints,
    topicKnowledge,
    topicVolumes,
    topics,
    users,
})
